import { render, staticRenderFns } from "./TicketAssignSeat.vue?vue&type=template&id=74e8920f"
import script from "./TicketAssignSeat.vue?vue&type=script&lang=js"
export * from "./TicketAssignSeat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports